import mitt, {
  Emitter
} from "mitt";

type MittInstance = Emitter<{
  OPEN_EASTER_RAFFLE: void;
  GOT_EASTER_EGG_CODE:void;
}>;

export const mittInstance: MittInstance = mitt();
